var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories"},[_c('h5',{staticClass:"categories__title"},[_vm._v(" "+_vm._s(_vm.$t('Categories'))+" ")]),_c('ul',{staticClass:"categories__list"},_vm._l((_vm.categories),function(category){return _c('li',{key:category.id,staticClass:"categories__list-item",class:{
        'categories__list-item--active': _vm.checkInSelected(category.id),
      },on:{"click":function($event){return _vm.setSelected(category.id)}}},[_c('ProductCategory',{attrs:{"id":category.id}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }